import styles from "./style.module.css";
import { useTranslation } from "react-i18next";
import { Intro, MobileIntro } from "src/assets";
import { DynamicTariffVideo } from "src/assets";
import { Box, Stack, useTheme } from "@mui/material";
import { useRef, useState } from "react";
import BoldTitle from "src/components/Displays/BoldTitle";
import { ThemeValues } from "../../../components/ThemeUsage/theme";
import { ThemeContext } from "../../../components/ThemeUsage/ThemeUsage";
import { useContext } from "react";
import { LogoSMA, Logo, LichtBlickLogoSMA } from "src/assets";

const Header = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const videoRef = useRef<HTMLVideoElement>(null);
  const themeName = useContext(ThemeContext);

  const [showVideo, setShowVideo] = useState({
    width: "0px",
    height: "0px",
  });

  document.addEventListener("fullscreenchange", (event) => {
    if (document.fullscreenElement === null) {
      videoRef.current?.pause();
      setShowVideo({
        width: "0px",
        height: "0px",
      });
    }
  });

  if (videoRef.current) {
    videoRef.current.onpause = function () {
      if (videoRef.current?.seeking) {
        return;
      }
      videoRef.current?.pause();
      setShowVideo({
        width: "0px",
        height: "0px",
      });
    };
  }

  const getLogo = () => {
    switch (themeName) {
      case ThemeValues.SMA:
        return <LogoSMA />;
      case ThemeValues.default:
        return <Logo color={"black"} />;
      default:
        return <></>;
    }
  };

  return (
    <>
      <video
        ref={videoRef}
        className={styles}
        width={showVideo.width}
        height={showVideo.height}
        style={{ marginBottom: showVideo.height === "0px" ? "0px" : "10px" }}
      >
        <source src={DynamicTariffVideo} type="video/mp4" />
      </video>

      <Stack
        sx={{
          alignItems: "center",
          width: "fit-content",
          height: "fit-content",
          maxHeight: "385px",
          position: "relative",
          borderRadius: "15px",
          overflow: "hidden",
          mt: 4,
        }}
      >
        <Stack
          sx={{
            display: { xs: "none", sm: "flex" },
          }}
        >
          <img
            src={Intro}
            alt="mobile-intro"
            style={{
              width: "100%",
              height: "100%",
            }}
          />

          <Stack
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: "250px",
              background:
                "linear-gradient(to top, rgba(0, 0, 0, 0.888), transparent)",
            }}
          />
        </Stack>
        <Stack
          sx={{
            display: { xs: "flex", sm: "none" },
          }}
        >
          <img
            src={MobileIntro}
            alt="mobile-intro"
            style={{
              width: "100%",
              height: "100%",
            }}
          />
          <Stack
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: "250px",
              background:
                "linear-gradient(to top, rgba(0, 0, 0, 0.888), transparent)",
            }}
          />
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          gap={{ xs: 1.5, sm: 2 }}
          sx={{
            position: "absolute",
            top: { xs: 12, sm: 24 },
            left: { xs: 12, sm: 24 },
            zIndex: 2,
            height: { xs: 30, sm: 50 },
            bgcolor: "#FFFFFF",
            p: "5px",
            borderRadius: "4px",
          }}
        >
          <Stack
            sx={{
              height: "100%",
              justifyContent: "center",
              "& svg": { height: "100%", width: "auto" },
            }}
          >
            {getLogo()}
          </Stack>

          <Stack
            sx={{
              height: "100%",
              justifyContent: "center",
              "& svg": { height: "100%", width: "auto" },
            }}
          >
            <LichtBlickLogoSMA color="white" />
          </Stack>
        </Stack>
        <Stack
          gap={2}
          sx={{
            maxWidth: { xs: "350px", sm: "800px" },
            position: "absolute",
            left: { lg: "25px", md: "100px", sm: "0px" },
            bottom: "29px",
            px: { xs: 4, lg: 0 },
          }}
        >
          <BoldTitle
            color={theme.palette.app.contrast}
            sx={{
              fontSize: { xs: "36px", md: "36px" },
              lineHeight: { xs: "37px", md: "37px" },
              fontWeight: 700,
            }}
            text={t("page.introduction.newTitleLichtblick")}
          />

          <BoldTitle
            color={theme.palette.app.contrast}
            sx={{
              fontSize: { xs: "20px", md: "24px" },
              lineHeight: { xs: "22px", md: "25px" },
              fontWeight: "400",
              whiteSpace: "pre-line",
            }}
            text={
              <>
                {t("page.introduction.subtitleLichtblick")}
                {"²"}
              </>
            }
          />

          <Stack direction="row" gap={1}>
            <Box
              sx={{
                bgcolor: "#DAECFA",
                color: theme.palette.text.primary,
                borderRadius: "20px",
                px: 2,
                py: 0.5,
                fontSize: { xs: "10px", md: "14px" },
                fontWeight: 500,
                whiteSpace: "nowrap",
              }}
            >
              {t("page.introduction.badgeAutomatic")}
            </Box>
            <Box
              sx={{
                bgcolor: "#DAECFA",
                color: theme.palette.text.primary,
                borderRadius: "20px",
                px: 2,
                py: 0.5,
                fontSize: { xs: "10px", md: "14px" },
                fontWeight: 500,
                whiteSpace: "nowrap",
              }}
            >
              {t("page.introduction.badgeCancelable")}
            </Box>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};

export default Header;
